import {
	getExperienceTracker, // eslint-disable-line no-restricted-imports
} from '@confluence/experience-tracker';
import { getLogger } from '@confluence/logger';

import { VALID_CONTENT_EXPERIENCES } from './dwellConstants';

const logger = getLogger('DwellTime:LastContentTracker');

export class LastSuccessfulContentTracker {
	constructor() {
		this.experienceTracker = getExperienceTracker();
		this.unsubscribeFromExperienceTracker = null;
		this.lastSuccessfulContent = null;
	}

	start() {
		this.unsubscribeFromExperienceTracker = this.experienceTracker.subscribe(
			this.onExperienceEvent,
		);
	}

	stop() {
		if (this.unsubscribeFromExperienceTracker) {
			this.unsubscribeFromExperienceTracker();
		}
	}

	onExperienceEvent = (event) => {
		if (event.action === 'taskSuccess' && VALID_CONTENT_EXPERIENCES.has(event.name)) {
			logger.debug`dwell content loaded within ${event.duration} seconds`;
			this.onContentExperienceEnd(event);
		}
	};

	onContentExperienceEnd = (event) => {
		this.lastSuccessfulContent = event;
	};

	getLastSuccessfulContent = () => this.lastSuccessfulContent;
}
